import React, { FC, Fragment } from "react";
import Icon from "~/components/Icon";
import Text from "~/components/Text";
import { Step } from "~/data/product/useGetEstimateDelivery";

const Divider = () => {
  return (
    <div className="mt-5 overflow-hidden">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="134"
        height="2"
        viewBox="0 0 134 2"
        fill="none"
      >
        <path d="M0 1H134" stroke="#3E3E3E" strokeDasharray="4 4" />
      </svg>
    </div>
  );
};

type Props = {
  steps: Step[];
};

const StepShipping = ({ steps }: Props) => {
  if (!steps?.length) return;
  return (
    <div className="gap-1 md:gap-4 justify-center flex w-full">
      {steps?.map((step: any, index: number) => (
        <Fragment key={step.title}>
          <div className="flex flex-col items-center gap-2 w-12">
            <div className="w-10 h-10 flex items-center justify-center border-solid border-[1px] border-[#3E3E3E] rounded-full">
              <Icon name={step.icon} size={20} />
            </div>
            <div className="flex flex-col items-center gap-1 text-center whitespace-nowrap">
              <Text type="label-4" weight={600}>
                {/* {step.title} */}
              </Text>
              <Text>{index === 0 ? "Today" : step.date}</Text>
            </div>
          </div>
          {index < steps?.length - 1 && <Divider />}
        </Fragment>
      ))}
    </div>
  );
};

export default StepShipping;
